import { Facebook, Instagram } from "lucide-react";
import { CDN, SMS_URL, EMAIL, PHONE_DISPLAY, PHONE_TEL, FACEBOOK_URL, INSTAGRAM_URL } from "../data";

export const Footer = () => (
  <footer className="footer section" data-testid="site-footer">
    <div className="foot-grid">
      <div>
        <img src={CDN + "hf_20260830_192030_168afa63-aa34-4c15-a6fa-45656f723f00.png"} alt="Lucho Gomez Connect logo" width="44" height="44" loading="lazy" />
        <p className="foot-word">Lucho Gomez Connect</p>
        <p className="foot-tag">One local contact. Many solutions. Kaua'i property care, land clearing, animal help &amp; property management — proudly serving all of Kaua'i.</p>
        <div className="socials">
          <a href={FACEBOOK_URL} target="_blank" rel="noreferrer" aria-label="Lucho Gomez Connect on Facebook" data-testid="footer-facebook-link"><Facebook size={18} /></a>
          <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" aria-label="Lucho Gomez Connect on Instagram" data-testid="footer-instagram-link"><Instagram size={18} /></a>
        </div>
      </div>
      <div>
        <h4>Contact</h4>
        <ul>
          <li><a href={"tel:" + PHONE_TEL} data-testid="footer-phone-link">Call {PHONE_DISPLAY}</a></li>
          <li><a href={SMS_URL} data-testid="footer-sms-link">Text {PHONE_DISPLAY}</a></li>
          <li><a href={"mailto:" + EMAIL} data-testid="footer-email-link">{EMAIL}</a></li>
          <li><a href={FACEBOOK_URL} target="_blank" rel="noreferrer">Facebook</a></li>
          <li><a href={INSTAGRAM_URL} target="_blank" rel="noreferrer">Instagram</a></li>
        </ul>
      </div>
      <div>
        <h4>Service area</h4>
        <ul><li>Lihu'e</li><li>Kapa'a</li><li>Princeville &amp; Hanalei</li><li>Po'ipu &amp; Koloa</li><li>All of Kaua'i</li></ul>
      </div>
      <div>
        <h4>Site</h4>
        <ul>
          <li><a href="#services">Services</a></li>
          <li><a href="#proof">Results</a></li>
          <li><a href="#faq">FAQ</a></li>
          <li><a href="#request">Request work</a></li>
          <li><a href="#payments">Pay an invoice</a></li>
        </ul>
      </div>
    </div>
    <div className="legal">
      <span>Luciano Gomez Consulting LLC. Licensed &amp; insured.</span>
      <span>Kaua'i, Hawaii &mdash; luchogomezconnect.com</span>
    </div>
  </footer>
);
